import { useEffect, useState } from "react";
import { useApiWithHandling } from "./useApiWithHandling";
import { ColdStorageRootsResponse } from "../types/coldStorage";

export const useNasRootFolders = (enabled: boolean) => {
  const { get } = useApiWithHandling();
  const [roots, setRoots] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setRoots([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    const fetchRoots = async () => {
      setLoading(true);
      try {
        await get<ColdStorageRootsResponse>("api/cold-storage/roots", {
          showLoader: false,
          showErrorSnackbar: true,
          showSuccessSnackbar: false,
          onSuccess: (response) => {
            if (cancelled) {
              return;
            }

            const names = (response?.data?.roots ?? []).map((root: { name: string }) => root.name);
            setRoots(names);
          },
          onError: () => {
            if (!cancelled) {
              setRoots([]);
            }
          },
          onFinally: () => {
            if (!cancelled) {
              setLoading(false);
            }
          },
        });
      } catch {
        if (!cancelled) {
          setRoots([]);
          setLoading(false);
        }
      }
    };

    void fetchRoots();
    return () => {
      cancelled = true;
    };
    // Fetch when NAS is selected; get is a stable API helper.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return { roots, loading };
};
